import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'
import type { ConfigureIntegrationResult } from '@cli-types/next-adapter/runtime.js'
import { appendEnvVars } from '@cli-utils/files.js'
import { hasRequiredIntegrationEnv } from './has-required-integration-env.js'
import { promptR2Config } from './prompt-r2-config.js'
import { promptRailwayBucketConfig } from './prompt-railway-bucket-config.js'
import { promptResendConfig } from './prompt-resend-config.js'
import { promptVercelBlobConfig } from './prompt-vercel-blob-config.js'

export async function configureIntegration(
  definition: BetterstartIntegrationDefinition,
  cwd: string,
  interactive: boolean
): Promise<ConfigureIntegrationResult> {
  if (definition.configure === 'resend') {
    if (interactive) {
      return promptResendConfig(cwd)
    }

    const envResult = appendEnvVars(cwd, definition.envSections)
    return {
      configured: hasRequiredIntegrationEnv(definition, cwd),
      addedEnvKeys: envResult.added,
      updatedEnvKeys: envResult.updated
    }
  }

  if (definition.configure === 'r2') {
    if (interactive) {
      return promptR2Config(cwd)
    }

    const envResult = appendEnvVars(cwd, definition.envSections)
    return {
      configured: hasRequiredIntegrationEnv(definition, cwd),
      addedEnvKeys: envResult.added,
      updatedEnvKeys: envResult.updated
    }
  }

  if (definition.configure === 'vercel-blob') {
    if (interactive) {
      return promptVercelBlobConfig(cwd)
    }

    const envResult = appendEnvVars(cwd, definition.envSections)
    return {
      configured: hasRequiredIntegrationEnv(definition, cwd),
      addedEnvKeys: envResult.added,
      updatedEnvKeys: envResult.updated
    }
  }

  if (definition.configure === 'railway-bucket') {
    if (interactive) {
      return promptRailwayBucketConfig(cwd)
    }

    const envResult = appendEnvVars(cwd, definition.envSections)
    return {
      configured: hasRequiredIntegrationEnv(definition, cwd),
      addedEnvKeys: envResult.added,
      updatedEnvKeys: envResult.updated
    }
  }

  const envResult = appendEnvVars(cwd, definition.envSections)
  return {
    configured: true,
    addedEnvKeys: envResult.added,
    updatedEnvKeys: envResult.updated
  }
}
